import EventEmitter from "eventemitter3";

// export const eventNames = {
//   STATUS_CHANGE: 'status_change'
// }

const Emitter = new EventEmitter();

export default Emitter;
